import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';

interface DishResponse {
  dishes: APIDish[];
  type: string;
}

export interface APIDish {
  _id: string;
  name: string;
  description: string;
  type: string;
  restaurantPrice: number;
  dishImages?: { url: string }[]; 
}

export interface Dish {
  id: string;
  name: string;
  description: string;
  category: string;
  price: number;
  image: string;
  dishImages: { url: string }[]; 
  currentImageIndex: number;
}

@Injectable({
  providedIn: 'root'
})
export class DishService {
   private baseUrl = `${environment.apiUrl}/api/udaan/dishes`;

  constructor(private http: HttpClient) {}

getDishes(restaurantId: string, searchQuery: string = '', type: string = ''): Observable<Dish[]> {
  let apiUrl = `${this.baseUrl}/${restaurantId}`;
  const params: string[] = [];

  if (searchQuery) {
    params.push(`search=${encodeURIComponent(searchQuery)}`);
  }

  if (type) {
    params.push(`type=${encodeURIComponent(type)}`);
  }

  if (params.length > 0) {
    apiUrl += `?${params.join('&')}`;
  }

  return this.http.get<DishResponse[]>(apiUrl).pipe(
    map(response =>
      response.flatMap(category =>
        category.dishes.map(dish => ({
          id: dish._id,
          name: dish.name,
          description: dish.description,
          category: category.type,
          price: dish.restaurantPrice,
          image: dish.dishImages?.[0]?.url || '',
          dishImages: dish.dishImages || [],
          currentImageIndex: 0
        }))
      )
    )
  );
}


}
